/**
 * Created by hernanherreros on 2019-07-21
 */

import * as React from 'react'
import { Route, Switch } from 'react-router'
import Activities from './Activities'
import ReservationProvider from '../../providers/Reservation/reservationProvider'

export default class Update extends React.Component {
  render() {
    return (
      <ReservationProvider useTimer={false}>
        <Switch>
          <Route path="/:congressSlug/update/:token/activities" component={Activities}/>
        </Switch>
      </ReservationProvider>
    )
  }
}